import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface MailOpenedIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MailOpenedIcon = ({ className, ...props }: MailOpenedIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 12L12 15.5L17 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M2 20V9.13238C2 8.42985 2.3686 7.77884 2.97101 7.41739L10.971 2.61739C11.6044 2.23738 12.3956 2.23738 13.029 2.6174L21.029 7.4174C21.6314 7.77884 22 8.42985 22 9.13238V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default MailOpenedIcon;
